import React, { useState, useEffect, useRef } from 'react';
import {
  GRAPHICS_QA_STATUS_SEQUENCE,
  matchesGraphicsQAStatus,
} from './graphicsQAStatusUtils';
import { connect } from 'react-redux';
import { Row, Col, Card, Button, Input, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faTimes, faAngleDown, faAngleUp, faCloudUploadAlt, faWindowClose } from "@fortawesome/free-solid-svg-icons";

import Download from '../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Download.svg'
import UploadButton_Dark from '../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/UploadButton_Dark.svg'
import Rename from '../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Rename.svg'
import Send from '../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Send.svg'
import NewTaskIcon from '../../../../../../../../designUtils/OpsDashboard/MyTasks/NewTaskIcon.svg';
import LoadingOverlay from 'react-loading-overlay';
import Loader from "react-loaders";
import FetchCMAssetChatsService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchCMAssetChatsService';
import AddCMAssetCommentsService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/AddCMAssetCommentsService';
import LinkCMImagesToGAFileService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/LinkCMImagesToGAFileService';
import AssetsVersionSaveService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/AssetsVersionSaveService';
import AssetStatusChangeService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/AssetStatusChangeService';
import UpdateCMFileAssetNameService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/UpdateCMFileAssetNameService';
import DeleteCMFileAssetService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/DeleteCMFileAssetService';
import FetchCMProductDataService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchCMProductDataService';
import CustomModal from '../../../../../../../Components/Modals/CustomModal';
import NewCMProductListScreen from '../AssetAnnotations/NewCMProductListScreen';
import SaveDestinationSubCategoriesForAssetsService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/SaveDestinationSubCategoriesForAssetsService';
import EditCloseIcon from '../../../../../../../../designUtils/ProjectDashboard/EditCloseIcon.svg';
import EditDoneIcon from '../../../../../../../../designUtils/ProjectDashboard/EditDoneIcon.svg';
import { Editor, SetInnerHtmlWithClassReplacement } from '../../../../../../../../Utils/Constants';
import ReactQuill from 'react-quill';
// import AnnotationCanvas ,{PhotoDisplay} from './SubCompents/ImageAnnotations/ViewAndEditCanvas';
import AnnotationCanvas ,{PhotoDisplay, collectPendingReplies, mergeStagedAfterReplySync} from '../AssetAnnotations/AnnotationCanvas'
import AnnotationIcon from '../../../../../../../../designUtils/ProjectDashboard/AnnotationIcon.svg'
import FilesMoveToAssetGalleryService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FilesMoveToAssetGalleryService';
import MoveToAssetGallery from '../../../../../../../../designUtils/OpsDashboard/MyTasks/MoveToAssetGallery.svg';
import notify from '../../../../../../../../Notifications/ToastifyActions';

import {INIT_IMAGES,
  CURRENT_USER,
  uuid,
  TOOLS,
  COLORS,} from '../AssetAnnotations/HardCodeImageData';
import SaveAssetsAnnonationsService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/SaveAssetsAnnonationsService';
import AssetAnnontationsReplyService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/AssetAnnontationsReplyService';
import ReadOnlyAnnotationCanvas from '../AssetAnnotations/ReadOnlyAnnotationCanvas';
import AmazonListingImageUpdatePopup from './AmazonListingImageUpdatePopup';
import ValidateMoveAssetService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/ValidateMoveAssetService';
const GraphicsQAImageDetails = (props) => {
  const {
    selectedImage,
    setSelectedImage,
    selectedStatus,
    setSelectedStatus,
    onClose,
    loggedInUser,
    file = [],
  } = props;
  const [selectedFileObject, setSelectedFileObject] = useState({ originalGA: '' });
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [selectedGraphicFiles, setSelectedGraphicFiles] = useState([]);
  const [alertMessageAi, setAlertMessageAi] = useState('');
  const [note, setNote] = useState('');
  const [noteList, setNoteList] = useState([]);
  const [isClickEditName, setIsClickEditName] = useState(false);
  const [editedFileName, setEditedFileName] = useState('');
  const [downloadAction, setDownloadAction] = useState(false)
  const [isUploadAiFIlesUi, setIsUploadAiFIlesUi] = useState(false);
  const [fileForDelete, setFileForDelete] = useState('');
  const [isDeletePopUpOpen, setIsDeletePopUpOpen] = useState(false)
  const [isDeleteConfirmPopUpOPen, setIsDeleteConfirmPopUpOPen] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [handleLinkFile, setHandleLinkFile] = useState(false);
  const [active, setActive] = useState(false);
  const [loadScreen, setLoadScreen] = useState(false);
  const [productList, setProductList] = useState(false);
  const [addProductsPopup, setAddProductsPopup] = useState(false)
  const [asinList,setAsinList] =useState([])
  const [expandedMessages, setExpandedMessages] = useState({});
  const [storeName,setStoreName]= useState()
  const [destinationSubCategories,setDestinationSubCategories]= useState('')
  const [amazonPosition, setAmazonPosition] = useState('0');
  const [isDuplicatePopupOpen, setIsDuplicatePopupOpen] = useState(false);
  const [pendingFiles, setPendingFiles] = useState([]);
  const [duplicateFiles, setDuplicateFiles] = useState([]);
  const [duplicateFileName, setDuplicateFileName] = useState(''); 
  const [isExpanded,setIsExpanded]=useState(false)
  const [confrimationForSubmition,setConfrimationForSubmition] = useState()
  const [annotationConfirmationPopup, setAnnotationConfirmationPopup] = useState(false);
  const [selectedTool, setSelectedTool] = useState('circle');
  const [selectedColor, setSelectedColor] = useState('#ff4444');
  const [annotationsPopup, setAnnotationsPopup] = useState(false);
  // const [selectedImage, setSelectedImage] = useState(null); // Assuming this is set somewhere
  const [stagedAnnotations, setStagedAnnotations] = useState([]);
  const [isCloseConfirmOpen, setIsCloseConfirmOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [originalAnnotations, setOriginalAnnotations] = useState([]);
  const [errorPopupOpen, setErrorPopupOpen] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState('');
  const [destinationCategories,setDestinationCategories]= useState('')
  const [isVersionAssetsOpen, setIsVersionAssetsOpen] = useState(false);
  const [selectedVersionImageFiles, setSelectedVersionImageFiles] = useState([]);
  const [alertMessageVersion, setAlertMessageVersion] = useState('');
  const [draggingVersion, setDraggingVersion] = useState(false);
  const [loadingVersionButton, setLoadingVersionButton] = useState(false);
  const [selectedVersionId, setSelectedVersionId] = useState('');
  const prevSelectedImageIdRef = useRef(null);
  const [isMoveAssetsPopup, setIsMoveAssetsPopup] = useState(false);
  
  useEffect(() => {
  const imageIdChanged =
    String(prevSelectedImageIdRef.current || '') !== String((selectedImage && selectedImage.id) || '');
  prevSelectedImageIdRef.current = selectedImage ? selectedImage.id : null;

  if (selectedImage) {
    const latestImage = file.find(f => f.id === selectedImage.id) || selectedImage;
    
    setAsinList(latestImage.asinList);
    // setDestinationSubCategories(latestImage.destinationSubCategoriesId ? latestImage.destinationSubCategoriesId : '');
    setDestinationCategories(
      latestImage.destinationCategoriesId ? latestImage.destinationCategoriesId : ''
    );
    setDestinationSubCategories(
      latestImage.destinationSubCategoriesId ? String(latestImage.destinationSubCategoriesId) : ''
    );
    
    setAmazonPosition(latestImage.amazonPosition || '0');
    
    if (!selectedVersionId) {
      setEditedFileName(latestImage.actualFileName || '');
    }
    
    // Update selected status from the latest image (or keep version status if a version is selected)
    if (!selectedVersionId) {
      setSelectedStatus(latestImage.status);
    }
    
    // Handle graphic file data
    if (latestImage.originalGA) {
      setSelectedFileObject({ originalGA: latestImage.originalGA });
    } else if (latestImage.graphicFile) {
      setSelectedFileObject({ originalGA: latestImage.graphicFile });
    } else {
      setSelectedFileObject({ originalGA: '' });
    }
    
    // Only reset version/UI state when switching to a different asset
    if (imageIdChanged) {
      setIsClickEditName(false);
      setAlertMessageAi('');
      setSelectedGraphicFiles([]);
      setHandleLinkFile(false);
      setIsUploadAiFIlesUi(false);
      setIsVersionAssetsOpen(false);
      setSelectedVersionImageFiles([]);
      setAlertMessageVersion('');
      setSelectedVersionId('');
    }
    
  } else {
    // Clear all states when no image selected
    setAsinList('');
    setDestinationSubCategories('');
    setAmazonPosition('0');
    setEditedFileName('');
    setSelectedFileObject({ originalGA: '' });
    setIsClickEditName(false);
    setAlertMessageAi('');
    setSelectedGraphicFiles([]);
    setHandleLinkFile(false);
    setIsUploadAiFIlesUi(false);
    setIsVersionAssetsOpen(false);
    setSelectedVersionImageFiles([]);
    setAlertMessageVersion('');
    setSelectedVersionId('');
  }
}, [selectedImage]);

  useEffect(() => {
    if (!selectedImage) {
      setNoteList([]);
      return;
    }
    const latestImage = (file || []).find((item) => item.id === selectedImage.id) || selectedImage;
    const versions = (latestImage && latestImage.versionAssets) || [];
    const versionAsset = versions.find(
      (version) => String(version.id) === String(selectedVersionId)
    );
    if (selectedVersionId && versionAsset) {
      setSelectedStatus(versionAsset.status);
      setEditedFileName(versionAsset.actualFileName || '');
      setDestinationSubCategories(
        versionAsset.destinationSubCategoriesId
          ? String(versionAsset.destinationSubCategoriesId)
          : (latestImage.destinationSubCategoriesId ? String(latestImage.destinationSubCategoriesId) : '')
      );
    } else if (latestImage) {
      setSelectedStatus(latestImage.status);
      setEditedFileName(latestImage.actualFileName || '');
      setDestinationSubCategories(
        latestImage.destinationSubCategoriesId ? String(latestImage.destinationSubCategoriesId) : ''
      );
    }

    const targetId = (selectedVersionId && versionAsset) ? versionAsset.id : latestImage.id;
    if (!targetId) {
      setNoteList([]);
      return;
    }

    let isMounted = true;
    const fetchChatData = async () => {
      setLoadScreen(true);
      try {
        const res = await FetchCMAssetChatsService(props.token, { assetDetails: targetId });
        if (isMounted) {
          setNoteList(res || []);
        }
      } finally {
        if (isMounted) {
          setLoadScreen(false);
        }
      }
    };

    fetchChatData();
    return () => {
      isMounted = false;
    };
  }, [selectedVersionId, selectedImage, file]);

  useEffect(() => {
    const activeFilter = props.statusFilter || 'All';
    if (activeFilter === 'All') {
      return;
    }
    if (selectedImage) {
      const latestImage = (file || []).find((item) => item.id === selectedImage.id) || selectedImage;
      const parentMatches = matchesGraphicsQAStatus(latestImage.statusText, activeFilter);
      if (parentMatches) {
        setSelectedVersionId('');
      } else {
        const versions = latestImage.versionAssets || [];
        const matchingVersion = versions.find((v) => matchesGraphicsQAStatus(v.statusText, activeFilter));
        if (matchingVersion) {
          setSelectedVersionId(matchingVersion.id);
        }
      }
    }
  }, [props.statusFilter, selectedImage]);

  const latestSelectedImage = (file || []).find((item) => selectedImage && item.id === selectedImage.id) || selectedImage;
  const versionAssets = ((latestSelectedImage && latestSelectedImage.versionAssets) || []).filter(
    (version) => String(version.id) !== String(latestSelectedImage && latestSelectedImage.id)
  );
  const selectedVersionAsset = selectedVersionId
    ? (versionAssets.find((version) => String(version.id) === String(selectedVersionId)) || null)
    : null;
  const isVersionFileSelected = !!selectedVersionAsset;
  const currentStatusId = Number(
    (selectedVersionAsset && selectedVersionAsset.status) || (selectedImage && selectedImage.status) || 0
  );
  const SIGN_OFF_DELETE_STATUS_IDS = [1, 2, 12]; // New, Internal Revision, Partner Revision
  const canSignOffOrDelete = SIGN_OFF_DELETE_STATUS_IDS.includes(currentStatusId);
  const actionAssetId = selectedVersionAsset
    ? selectedVersionAsset.id
    : (selectedImage ? selectedImage.id : null);
  const destIdFromVersion = selectedVersionAsset && selectedVersionAsset.destinationSubCategoriesId;
  const destIdFromOriginal = latestSelectedImage && latestSelectedImage.destinationSubCategoriesId;
  const currentDestinationId = destIdFromVersion || destIdFromOriginal || '';
  const activeAnnotations = Array.isArray(
    selectedVersionAsset
      ? selectedVersionAsset.annotations
      : (selectedImage && selectedImage.annotations)
  )
    ? (selectedVersionAsset
      ? (selectedVersionAsset.annotations || [])
      : ((selectedImage && selectedImage.annotations) || []))
    : [];
  const activeAssetsAnnotationsId = selectedVersionAsset
    ? selectedVersionAsset.assetsAnnotationsId
    : (selectedImage && (selectedImage.assetsAnnotationsId || selectedImage.cmAssetsAnnotationsId));
  const currentFileHasAnnotations = Array.isArray(activeAnnotations)
    && activeAnnotations.some((ann) => ann && ann.id);
  // Full annotation tools for New / Internal Revision / Partner Revision
  const isAnnotationReadOnly = [5, 6, 14].includes(currentStatusId);
  const displayImage = selectedImage
    ? (selectedVersionAsset
        ? {
            ...selectedImage,
            id: selectedVersionAsset.id,
            filePath: selectedVersionAsset.filePath,
            actualFileName: selectedVersionAsset.actualFileName,
            fileName: selectedVersionAsset.fileName,
            fileSize: selectedVersionAsset.fileSize,
            updatedAt: selectedVersionAsset.updatedAt,
            annotations: selectedVersionAsset.annotations || [],
            assetsAnnotationsId: selectedVersionAsset.assetsAnnotationsId,
            status: selectedVersionAsset.status || null,
            statusText: selectedVersionAsset.statusText || '',
            statuscolor: selectedVersionAsset.statuscolor || '',
          }
        : selectedImage)
    : null;
  const displayStatusId = Number(
    (displayImage && displayImage.status) || (selectedImage && selectedImage.status) || 0
  );
  const displayStatusText = (
    (displayImage && displayImage.statusText) || (selectedImage && selectedImage.statusText) || ''
  ).trim();
  const isApprovedGraphics = displayStatusText === 'Approved' || displayStatusId === 5;

  const syncAnnotationsFromFileList = (fileList, versionIdOverride) => {
    if (!fileList || !selectedImage) return [];
    const updatedParent = fileList.find((file) => file.id === selectedImage.id);
    if (!updatedParent) return [];

    // Refresh selected image data without treating it as a navigation change
    setSelectedImage(updatedParent);

    const versions = updatedParent.versionAssets || [];
    const preferredVersionId = versionIdOverride || selectedVersionId;
    if (preferredVersionId && String(preferredVersionId) !== String(updatedParent.id)) {
      const targetVersion = versions.find(
        (version) => String(version.id) === String(preferredVersionId)
      );
      if (targetVersion) {
        if (String(selectedVersionId || '') !== String(targetVersion.id)) {
          setSelectedVersionId(targetVersion.id);
        }
        return Array.isArray(targetVersion.annotations)
          ? targetVersion.annotations.filter((ann) => ann && ann.id)
          : [];
      }
    }

    return Array.isArray(updatedParent.annotations)
      ? updatedParent.annotations.filter((ann) => ann && ann.id)
      : [];
  };
  
const asinArray=props.selectedProjectData.asin && props.selectedProjectData.asin.split(',')
  const addCMAssetChats = () => {
    if (!actionAssetId) return;
    let data = {
      note,
      integerId:props.selectedProjectData.integerId,
      assetCategory:selectedImage.assetCategory,
      // assetIdentifier:selectedImage.asinList,
      // asinList:selectedImage.asinList,
      asinList:props.selectedASIN,
      assetIdentifier: props.selectedProjectData.brand,
      projectId: props.selectedProjectData.projectId,
      subCategoryId:selectedImage.assetSubCategory,
      assetDetails: actionAssetId,
      action:''
    };
    AddCMAssetCommentsService(props.token, data).then((res) => {
      // if (!res) return;
      if(res){
        console.log(res);
        setNoteList(res.noteList);
        setNote('');
        const updatedStatus = res.updatedStatus;
        if (res.fileList && res.fileList.fileList) {
          props.setFileList(res.fileList.fileList)
        }
        if (res.fileList && res.fileList.assetStatusCount) {
          props.setAssetsStatusCount(res.fileList.assetStatusCount);
        }
        const isApprovedStatus =
          Number(selectedImage && selectedImage.status) === 5 ||
          Number(selectedImage && selectedImage.status) === 10 ||
          Number(currentStatusId) === 5 ||
          Number(currentStatusId) === 10 ||
          (selectedImage && selectedImage.statusText && selectedImage.statusText.toLowerCase() === 'approved');

        if (updatedStatus && updatedStatus.id && !isApprovedStatus) {
          setSelectedStatus(updatedStatus.id);
          if (!selectedVersionAsset) {
            setSelectedImage({
              ...selectedImage,
              statusText: updatedStatus.text,
              statuscolor: updatedStatus.color,
              status: updatedStatus.id,
            });
          }
        }
      }
     
    });
  };
  const toggleReadMore = (index) => {
    setExpandedMessages((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  const handleImageClick = (file) => {
    console.log(file)
    setSelectedFileObject({originalGA: file.originalGA? file.originalGA:null});
    setSelectedImage(file);
    setSelectedStatus(file.status || 'new');
    setSelectedVersionId('');
  };

  const handleVersionSidebarClick = (parentFile, version, event) => {
    if (event) {
      event.stopPropagation();
    }
    setSelectedFileObject({ originalGA: parentFile.originalGA ? parentFile.originalGA : null });
    setSelectedImage(parentFile);
    setSelectedVersionId(version.id);
    setSelectedStatus(version.status || parentFile.status || 'new');
  };

  const renderSidebarAssetCard = (assetItem, options = {}) => {
    const {
      isSelected = false,
      onClick,
      label,
      isVersion = false,
      amazonPosition = '',
    } = options;

    return (
      <Card
        className={`mb-2 p-2 text-center grahics-qa-image-card vertical-scroll-blur ${
          isVersion ? 'graphics-qa-version-sidebar-card' : 'mt-3'
        } ${isSelected ? 'qa-selected-blur' : ''}`}
        onClick={onClick}
        style={{ cursor: 'pointer' }}
      >
        <img
          src={assetItem.filePath}
          alt={assetItem.actualFileName}
          className={`grahics-qa-asset-img-vertical-scroll graphics-qa-container ${
            isVersion ? 'graphics-qa-version-sidebar-img' : ''
          }`}
        />
        <div className="d-flex justify-content-between align-items-center mt-1 px-1">
          <span className="ml-1">
            <b style={{ color: '#B01A00' }}>#{amazonPosition || assetItem.amazonPosition || ''}</b>
          </span>
          <div className="text-right">
            {label && (
              <small className="d-block text-muted" style={{ fontSize: '10px' }}>
                {label}
              </small>
            )}
            <b>{assetItem.id}</b>
          </div>
        </div>
      </Card>
    );
  };

  // Function to check for duplicate files
  const checkForDuplicates = (newFiles) => {
    const duplicates = [];
    
    newFiles.forEach(newFile => {
      // Check against currently selected files
      const matchingSelectedFiles = selectedGraphicFiles.filter(f => f.name === newFile.name);
      matchingSelectedFiles.forEach(matchingFile => {
        duplicates.push({
          fileName: newFile.name,
          newFileName: newFile.name,
          existingFileId: null,
          existingFileName: matchingFile.name,
          source: 'selected',
          assetList: [] // No asset mapping for selected files
        });
      });
  
      // Check against existing original files
      const matchingOriginalFiles = (props.allOriginalFiles || []).filter(f => f.actualFileName === newFile.name);
      matchingOriginalFiles.forEach(matchingFile => {
        duplicates.push({
          fileName: newFile.name,
          newFileName: newFile.name,
          existingFileId: matchingFile.id,
          existingFileName: matchingFile.actualFileName,
          source: 'existing',
          assetList: matchingFile.assetList || [] // Asset list from backend
        });
      });
    });
    
    return duplicates;
  };
  // Function to add files after duplicate check
  const addFilesAfterCheck = (filesToAdd) => {
    const allowedExtensions = ['ai', 'psd', 'eps'];
    
    const filteredFiles = filesToAdd.filter(file => {
      const extension = file.name.split('.').pop().toLowerCase();
      return allowedExtensions.includes(extension);
    });

    if (selectedGraphicFiles.length < 1) {
      setSelectedGraphicFiles(prevFiles => [...prevFiles, ...filteredFiles]);
      setActive(true);

      const invalidFiles = filesToAdd.filter(file => 
        !allowedExtensions.includes(file.name.split('.').pop().toLowerCase())
      );

      if (invalidFiles.length > 0) {
        setAlertMessageAi(`Invalid file(s) detected: ${invalidFiles.map(file => file.name).join(', ')}. Only ai, psd, and eps files are allowed.`);
      } else {
        setAlertMessageAi('');
      }
    } else {
      setAlertMessageAi('You can only select one file at a time. Please remove the existing file before selecting a new one.');
    }
  };

  // Handle duplicate confirmation
  const handleDuplicateConfirmation = (proceed) => {
    if (proceed) {
      addFilesAfterCheck(pendingFiles);
    }
    setIsDuplicatePopupOpen(false);
    setPendingFiles([]);
    setDuplicateFiles([]); // Clear duplicate files array
    setDuplicateFileName('');
    
    // Clear the file input to allow re-selection of the same file
    const fileInput = document.getElementById("graphicFileInput");
    if (fileInput) {
      fileInput.value = '';
    }
  };
  const handleSubmitFile = () => {
    // setLoadingButton(true);
    setAlertMessageAi('');
    if (handleLinkFile === false && selectedGraphicFiles.length < 1) {
      setAlertMessageAi('Please select or upload a file to continue.');
      setLoadingButton(false);
      return true;
    }
    
    const data = new FormData();
    data.append("integerId", props.selectedProjectData.integerId);
    data.append("assetCategory", props.selectedSubCategories ? props.selectedSubCategories.assetCategory : '');
    data.append("subCategoryId", props.selectedSubCategories ? props.selectedSubCategories.id : '');
    data.append("assetIdentifier", props.assetIdentifier ? props.assetIdentifier : '');
    data.append("asinList", props.selectedASIN?props.selectedASIN : 'Unmapped Assets');
    data.append("projectId", props.selectedProjectData.projectId ? props.selectedProjectData.projectId : '');
    data.append("notes", '');
    data.append("assetDetails", selectedImage.id);
    data.append("amazonPosition", amazonPosition ? amazonPosition : '');
    
    if (handleLinkFile !== false) {
      data.append("handleLinkFile", handleLinkFile);
      data.append("attachmentFiles1", 0);
    } else {
      for (let i = 0; i < selectedGraphicFiles.length; i++) {
        data.append("attachmentFiles1", selectedGraphicFiles[i]);
      }
      data.append("handleLinkFile", 0);
    }
    const currentImageId = selectedImage.id;
    
    LinkCMImagesToGAFileService(props.token, data).then((res) => {
      if (res) {
        console.log("Response fileList:", res.fileList); 
        setSelectedGraphicFiles([]);
        setHandleLinkFile(false);
        
        const imageFiles = res.fileList.filter(file => {
          const extension = file.fileName.toLowerCase().split('.').pop();
          return ['jpg', 'png', 'jpeg'].includes(extension);
        });
        
        // Update the file list
        props.setFileList(imageFiles);
        
        // Find the updated version of the current image
        const updatedCurrentImage = imageFiles.find(file => file.id === currentImageId);
        
        if (updatedCurrentImage) {
          // Update the selected image with the latest data
          setSelectedImage(updatedCurrentImage);
          setSelectedStatus(updatedCurrentImage.status);
          
          // Update the file object to show the new graphic file
          if (updatedCurrentImage.originalGA) {
            setSelectedFileObject({ originalGA: updatedCurrentImage.originalGA });
          } else if (updatedCurrentImage.graphicFile) {
            setSelectedFileObject({ originalGA: updatedCurrentImage.graphicFile });
          }
        }
        
        setIsUploadAiFIlesUi(false);
        setLoadingButton(false);
      } else {
        setAlertMessageAi('Failed to link graphic file. Please try again.');
        setLoadingButton(false);
      }
    }).catch((error) => {
      console.error('Upload error:', error);
      setAlertMessageAi('An unexpected error occurred.');
      setLoadingButton(false);
    });
  };

  const handleSaveVersionAssets = () => {
    setAlertMessageVersion('');
    if (selectedVersionImageFiles.length < 1) {
      setAlertMessageVersion('Please select at least one image file.');
      return;
    }

    setLoadingVersionButton(true);
    const data = new FormData();
    data.append('integerId', props.selectedProjectData.integerId);
    data.append('assetCategory', props.selectedSubCategories ? props.selectedSubCategories.assetCategory : '');
    data.append('subCategoryId', props.selectedSubCategories ? props.selectedSubCategories.id : '');
    data.append('assetIdentifier', props.assetIdentifier || props.selectedProjectData.brand || '');
    data.append(
      'asinList',
      props.selectedASIN === 'Unmapped Assets' || !props.selectedASIN ? '' : props.selectedASIN
    );
    data.append('projectId', props.selectedProjectData.projectId || '');
    data.append('parentAssetId', selectedImage.parentAssetId || selectedImage.id);
    data.append('destinationSubCategories', destinationSubCategories || '');
    data.append('amazonPosition', amazonPosition || selectedImage.amazonPosition || '');

    if (selectedImage.url) {
      data.append('url', selectedImage.url);
    }
    if (selectedImage.cm_originalGAId) {
      data.append('cm_originalGAId', selectedImage.cm_originalGAId);
    } else if (selectedFileObject.originalGA && selectedFileObject.originalGA[0]) {
      data.append('cm_originalGAId', selectedFileObject.originalGA[0].id);
    }

    selectedVersionImageFiles.forEach((file) => {
      data.append('attachmentFiles', file);
    });
    console.log(data)
// return
    AssetsVersionSaveService(props.token, data).then((res) => {
      if (res && res.success) {
        setSelectedVersionImageFiles([]);
        setIsVersionAssetsOpen(false);
        if (res.fileList && res.fileList.fileList) {
          props.setFileList(res.fileList.fileList);
          const parentId = selectedImage.parentAssetId || selectedImage.id;
          const updatedImage = res.fileList.fileList.find((fileItem) => fileItem.id === parentId);
          if (updatedImage) {
            setSelectedImage(updatedImage);
            setSelectedStatus(updatedImage.status);
            const versions = updatedImage.versionAssets || [];
            setSelectedVersionId('');
            if (versions.length > 0) {
              setSelectedVersionId(versions[versions.length - 1].id);
            }
          }
        }
        if (res.fileList && res.fileList.assetStatusCount) {
          props.setAssetsStatusCount(res.fileList.assetStatusCount);
        }
        if (res.updatedAsinCount && props.setAsinAssetCounts) {
          props.setAsinAssetCounts(prevCounts => ({
            ...prevCounts,
            ...res.updatedAsinCount
          }));
        }
      }
      setLoadingVersionButton(false);
    }).catch(() => {
      setLoadingVersionButton(false);
    });
  };

  
  const handleChangeStatus = (flag) => {
    let status=''
    if(flag=='PauseResume'){
      status= Number(selectedStatus) === 3 ? 2 : 3 //3 Pause 2 inprogress
    }
    if(flag=='SendforApproval'){
      status= 6 //Internal Approved
    }
    let data={
      status:status,
      selectedImgId:actionAssetId,
      integerId:props.selectedProjectData.integerId,
      assetCategory:selectedImage.assetCategory,
      asinList:props.selectedASIN?props.selectedASIN:'',
      assetIdentifier: props.selectedProjectData.brand,
      // assetIdentifier:selectedImage.asinList,
      projectId: props.selectedProjectData.projectId,
      subCategoryId:selectedImage.assetSubCategory,
    }
    AssetStatusChangeService(props.token,data).then((res=>{
      if(res){
        if (res.success === false || res.error) {
          setConfrimationForSubmition(false);
          if (flag === 'SendforApproval') {
            setAnnotationConfirmationPopup(true);
          }
          return;
        }
        console.log(res);
        onClose()
        if (res.fileList && res.fileList.fileList) {
          props.setFileList(res.fileList.fileList)
        }
        if (res.fileList && res.fileList.assetStatusCount) {
          props.setAssetsStatusCount(res.fileList.assetStatusCount);
        }
      }
    }))
    if (status) {
      setSelectedStatus(status);
    }
    setConfrimationForSubmition(false)
  };

  const handleLinkfile = (value) => {
    console.log(value);
    setHandleLinkFile(value)
    if (value == '') {
      setActive(false)
    }
    else {
      setActive(true)
    }
  }

  // Updated handleGraphicFileChange with duplicate detection
  const handleGraphicFileChange = (e) => {
    const files = Array.from(e.target.files);
    
    // Check for duplicates
    const duplicates = checkForDuplicates(files);
    
    if (duplicates.length > 0) {
      setPendingFiles(files);
      setDuplicateFiles(duplicates); // Store all duplicate details
      setDuplicateFileName(duplicates[0].fileName); // Keep first one for backward compatibility
      setIsDuplicatePopupOpen(true);
      return;
    }
    
    // If no duplicates, proceed normally
    addFilesAfterCheck(files);
    
    // Clear the file input after processing
    e.target.value = '';
  };

  const handleGraphicRemoveFile = (file) => {
    const updatedFiles = selectedGraphicFiles.filter((f) => f !== file);
    setSelectedGraphicFiles(updatedFiles);
  };

  const handleGADragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  // Updated handleGADrop with duplicate detection
  const handleGADrop = (e) => {
    e.preventDefault();
    setDragging(false);
  
    const files = Array.from(e.dataTransfer.files);
    
    // Check for duplicates
    const duplicates = checkForDuplicates(files);
    
    if (duplicates.length > 0) {
      setPendingFiles(files);
      setDuplicateFiles(duplicates); // Store all duplicate details
      setDuplicateFileName(duplicates[0].fileName); // Keep first one for backward compatibility
      setIsDuplicatePopupOpen(true);
      return;
    }
    
    // If no duplicates, proceed normally
    addFilesAfterCheck(files);
  };

  const handleGADragEnter = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleGADragLeave = (e) => {
    e.preventDefault();
    setDragging(false);
  };

  const handleRenameFileAssets = () => {
    setIsClickEditName(true);
    setEditedFileName((displayImage && displayImage.actualFileName) || selectedImage.actualFileName);
  };


  const handleSaveRename = () => {
    let data = {
      integerId: props.selectedProjectData.integerId,
      assetCategory: props.selectedSubCategories.assetCategory,
      // assetIdentifier: props.selectedASIN,
      asinList:props.selectedASIN,
      assetIdentifier: props.selectedProjectData.brand,
      subCategoryId: props.selectedSubCategories.id,
      projectId: props.selectedProjectData.projectId,
      newName: editedFileName,
      amazonPositionNo: amazonPosition === '' ? null : amazonPosition,
      fileId: actionAssetId,
    };
    
    UpdateCMFileAssetNameService(props.token, data).then((response) => {
      if (response) {
        // Add null checks and use the correct response structure
        const fileList = response.response&&response.response.fileList || response.fileList;
        
        if (fileList && Array.isArray(fileList)) {
          fileList.forEach((file) => {
            if (file.id === selectedFileObject.id) {
              setSelectedFileObject(file);
            }
          });
        }
        
        console.log(response);
        const responsePosition = response.amazonPositionNo;
        const finalPosition = responsePosition === null || responsePosition === undefined || responsePosition === '0' ? '' : responsePosition;
        
        setAmazonPosition(finalPosition);
        setEditedFileName(response.newName);
        setIsClickEditName(false);

        setSelectedImage((prev) => {
          if (!prev) return prev;
          if (!selectedVersionAsset) {
            return {
              ...prev,
              actualFileName: response.newName,
              amazonPosition: response.amazonPositionNo
            };
          }
          return {
            ...prev,
            versionAssets: (prev.versionAssets || []).map((version) =>
              String(version.id) === String(actionAssetId)
                ? { ...version, actualFileName: response.newName }
                : version
            )
          };
        });
        
        // Use the correct nested structure
        if (response.response&&response.response.fileList) {
          props.setFileList(response.response.fileList);
          
          const imageFiles = response.response.fileList.filter(file => {
            const extension = file.fileName.toLowerCase().split('.').pop();
            return ['jpg', 'png', 'jpeg'].includes(extension);
          });
          props.setFileList(imageFiles);
        }
      }
    }).catch((error) => {
      console.error('Error updating file name:', error);
      // Handle error appropriately
    });
  };

  const handleDownloadImage = async (url, type, downloadFileName) => {
    setDownloadAction(type);
    try {
      const response = await fetch(url, {
        method: 'GET',
        referrerPolicy: 'no-referrer',
        cache: 'no-store',
      });

      if (!response.ok) throw new Error(`Failed to fetch: ${url}`);

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const downloadLink = document.createElement('a');
      downloadLink.href = blobUrl;

      if (type === "DownloadeImage") {
        downloadLink.download = downloadFileName
          || (displayImage && displayImage.actualFileName)
          || (selectedImage && selectedImage.actualFileName)
          || 'downloaded_image';
      } else if (type === "DownloadGraphic" && selectedFileObject.originalGA && selectedFileObject.originalGA[0]) {
        downloadLink.download = selectedFileObject.originalGA[0].actualFileName || 'graphic_file';
      } else {
        downloadLink.download = downloadFileName || 'downloaded_file';
      }

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Failed to download file:', error);
    } finally {
      setDownloadAction(false);
    }
  };

  const handleDeleteFile = (file, fromEditable) => {
    const deleteTarget = file || displayImage || selectedImage;
    const deleteFileId = (deleteTarget && deleteTarget.id)
      || actionAssetId
      || (selectedImage && selectedImage.id);
    const parentAssetId = selectedImage && selectedImage.id;
    const isVersionDelete = parentAssetId
      && deleteFileId
      && String(deleteFileId) !== String(parentAssetId);

    if (!deleteFileId) return;

    let data = {
      integerId: props.selectedProjectData.integerId,
      assetCategory: props.selectedSubCategories.assetCategory,
      asinList: props.selectedASIN,
      assetIdentifier: props.selectedProjectData.brand,
      projectId: props.selectedProjectData.projectId,
      subCategoryId: props.selectedSubCategories.id,
      fileId: deleteFileId,
      fileType: fromEditable === 'true' ? 'graphic' : 'image',
    };
    DeleteCMFileAssetService(props.token, data).then((res) => {
      if (res) {
        console.log(res);
        props.setFileList(res.fileList.fileList);
        if (res.fileList && res.fileList.assetStatusCount) {
          props.setAssetsStatusCount(res.fileList.assetStatusCount);
        }
        if (res.fileList.updatedAsinCount) {
          console.log("Updated ASIN count:", res.fileList.updatedAsinCount);
          props.setAsinAssetCounts(prevCounts => ({
            ...prevCounts,
            ...res.fileList.updatedAsinCount
          }));
        }

        if (isVersionDelete) {
          setSelectedVersionId('');
          const updatedParent = (res.fileList.fileList || []).find(
            (item) => String(item.id) === String(parentAssetId)
          );
          if (updatedParent) {
            setSelectedImage(updatedParent);
          }
        } else {
          onClose();
          setSelectedFileObject();
        }

        setFileForDelete(null);
        setIsDeleteConfirmPopUpOPen(false);
      }
    });
  };
  
  const handleSelectProduct=()=>{
    setStoreName(props.selectedProjectData.storeName);
    let data={
        // integerID:intergerId
        asinList:props.selectedProjectData.asin,
          projectId: props.selectedProjectData.projectId,
          integerID: props.selectedProjectData.integerId
    }
    FetchCMProductDataService(props.token,data).then((res)=>{
        if(res){
            console.log(res)
            setProductList(res.productsList)
            setAddProductsPopup(true)
        }
    })
  } 
  const handleDestinationSubCategories = (e) => {
    const value = e.target.value;

  const selectedSubCat = props.existingSubCategories.find(
    sc => sc.id == value
  );

  if (!selectedSubCat) return;

  //  Sub-category ID
  setDestinationSubCategories(value);

  //  Category ID (FIXED)
  setDestinationCategories(selectedSubCat.assetCategory);

  //  Store on selected image (for Move API)
  setSelectedImage(prev => ({
    ...prev,
    destinationSubCategoriesId: value,
    destinationCategoriesId: selectedSubCat.assetCategory
  }));
    let data = {
      integerId: props.selectedProjectData.integerId,
      assetCategory: props.selectedSubCategories.assetCategory,
      // assetIdentifier: props.selectedASIN,
      // asinList:selectedImage.asinList,
      asinList:props.selectedASIN,
      assetIdentifier: props.selectedProjectData.brand,
      projectId: props.selectedProjectData.projectId,
      subCategoryId: props.selectedSubCategories.id,
      fileId: actionAssetId || selectedImage.id,
      destination: value
    };
  
    SaveDestinationSubCategoriesForAssetsService(props.token, data).then((res) => {
      if (res && res.fileList && res.fileList.fileList) {

        // keep your existing line
        props.setFileListOfAssets(res.fileList.fileList);
    
        const updatedImage = res.fileList.fileList.find(
          f => f.id === selectedImage.id
        );
    
        if (updatedImage) {
          setSelectedImage(updatedImage);
        }
      }
    });
  };
  const handleQuillChange = (value, delta, source, editor) => {
    const plainText = editor.getText().trim();
    setNote(plainText === '' ? '' : value);
};    
  const replaceNoteText = SetInnerHtmlWithClassReplacement(noteList);

  const ReadMore = ({ htmlContent, maxLength, onReadMoreClick }) => {
    const isLong = htmlContent.length > maxLength;
    const truncatedContent = isLong ? htmlContent.substring(0, maxLength) + '...' : htmlContent;

    return (
        <div>
            <span
                className="issue-description-set d-flex flex-wrap"
                dangerouslySetInnerHTML={{ __html: truncatedContent }}
            />
            {isLong && (
                <span
                    style={{ fontSize: '13px' }}
                    className="cursor-pointer d-flex justify-content-end text-primary"
                    onClick={() => onReadMoreClick(htmlContent)}
                >
                    ....Read More
                </span>
            )}
        </div>
    );
};
  const openNoteModal = (fullMessage) => {
    setExpandedMessages(fullMessage);
    setIsExpanded(true);
};

const handleAnnotaionPopup = () => {
  const sourceAnnotations = Array.isArray(
    selectedVersionAsset ? selectedVersionAsset.annotations : (selectedImage && selectedImage.annotations)
  )
    ? (selectedVersionAsset ? (selectedVersionAsset.annotations || []) : (selectedImage.annotations || []))
    : [];
  const cleanAnnotations = sourceAnnotations
    .filter((ann) => ann && ann.id)
    .map(({ isNew, isEdited, ...ann }) => ({
      ...ann,
      replies: Array.isArray(ann.replies) ? ann.replies : [],
    }));
  setOriginalAnnotations(JSON.parse(JSON.stringify(cleanAnnotations)));
  setStagedAnnotations(cleanAnnotations);
  setAnnotationsPopup(true);
};

  // This function ADDS a new annotation to the LOCAL STAGE only.
  const handleStageAnnotation = (coords, type, color, comment) => {
    const newAnnotationObject = {
      id: uuid(), 
      type,
      color,
      coordinates: coords,
      comment,
      userName: props.loggedInUser, 
      createdAt: new Date().toISOString(),
      replies: [],
      isNew: true
    };
    setStagedAnnotations(prev => [...(Array.isArray(prev) ? prev : []), newAnnotationObject]);
  };

  //  This function EDITS an annotation in the LOCAL STAGE only.
  const handleStageEdit = (annotationId, newComment) => {
    if (!newComment || newComment.trim() === '') {
      return; 
    }
    setStagedAnnotations(prev =>
      prev.map(ann => {
        if (ann.id === annotationId) {
          // If the comment text has NOT changed, just return the annotation as is.
          if (ann.comment === newComment) {
            return ann;
          }
          // If the comment HAS changed, update it and add the "isEdited" flag.
          return { ...ann, comment: newComment, isEdited: true };
        }
        return ann;
      })
    );
  };

  // This function DELETES an annotation from the LOCAL STAGE only.
  const handleStageDelete = (annotationId) => {
    setStagedAnnotations(prev => prev.filter(ann => ann.id !== annotationId));
  };

  // This function saves ALL staged annotations to the backend.
  const handleSaveAllAnnotations = () => {
    if (!hasUnsavedChanges || isSaving) {
      return;
    }
    setIsSaving(true);

    const pendingReplies = collectPendingReplies(stagedAnnotations);
    const annotationsToSave = stagedAnnotations.map(({ isNew, isEdited, replies, ...ann }) => ann);

    let data = {
      integerId: props.selectedProjectData.integerId,
      assetCategory: props.selectedSubCategories.assetCategory,
      // assetIdentifier: props.selectedASIN,
      // asinList:selectedImage.asinList,
      asinList:props.selectedASIN,
      assetIdentifier: props.selectedProjectData.brand,
      projectId: props.selectedProjectData.projectId,
      subCategoryId: props.selectedSubCategories.id,
      assetId: actionAssetId,
      annotations: annotationsToSave,
    };

    const flushPendingReplies = (fileList, assetsAnnotationsId) => {
      if (!pendingReplies.length) return Promise.resolve(null);
      return pendingReplies.reduce(
        (chain, pending) => chain.then(() => AssetAnnontationsReplyService(props.token, {
          id: pending.annotationId,
          comment: pending.comment,
          assetId: actionAssetId,
          assetsAnnotationsId: assetsAnnotationsId || null,
          integerId: props.selectedProjectData.integerId,
          assetCategory: props.selectedSubCategories.assetCategory,
          assetIdentifier: props.selectedProjectData.brand,
          projectId: props.selectedProjectData.projectId,
          subCategoryId: props.selectedSubCategories.id,
          asinList: props.selectedASIN,
        })),
        Promise.resolve()
      );
    };

    SaveAssetsAnnonationsService(props.token, data).then((res) => {
      if (res) {
        const newFileList = res.fileList && res.fileList.fileList;
        const versionOverride = selectedVersionAsset ? actionAssetId : null;
        const updatedParent = newFileList && newFileList.find((file) => file.id === selectedImage.id);
        const versionMatch = versionOverride && updatedParent
          ? (updatedParent.versionAssets || []).find((v) => String(v.id) === String(versionOverride))
          : null;
        const assetsAnnotationsId = versionMatch
          ? versionMatch.assetsAnnotationsId
          : (updatedParent && updatedParent.assetsAnnotationsId);

        return flushPendingReplies(newFileList, assetsAnnotationsId).then((replyRes) => {
          const finalRes = replyRes || res;
          const finalFileList = (finalRes.fileList && finalRes.fileList.fileList) || newFileList;
          if (finalFileList) {
            props.setFileList(finalFileList);
            const syncedAnnotations = syncAnnotationsFromFileList(finalFileList, versionOverride);
            const fallbackAnnotations = annotationsToSave.map((ann) => ({
              ...ann,
              replies: [],
            }));
            const sourceAnnotations = (syncedAnnotations && syncedAnnotations.length)
              ? syncedAnnotations
              : fallbackAnnotations;
            const cleanAnnotations = sourceAnnotations.map(({ isNew, isEdited, ...ann }) => ({
              ...ann,
              replies: Array.isArray(ann.replies) ? ann.replies : [],
            }));
            setStagedAnnotations(cleanAnnotations);
            setOriginalAnnotations(JSON.parse(JSON.stringify(cleanAnnotations)));
          }
          if ((finalRes.fileList && finalRes.fileList.assetStatusCount) || (res.fileList && res.fileList.assetStatusCount)) {
            props.setAssetsStatusCount(
              (finalRes.fileList && finalRes.fileList.assetStatusCount) || res.fileList.assetStatusCount
            );
          }
          setAnnotationsPopup(false);
        });
      }
      return null;
    }).catch(error => {
      console.error("Failed to save annotations:", error);
    }).finally(() => {
      setIsSaving(false);
    });
  };
  const handleMoveAsset = () => {
    const targetAssetId = actionAssetId || (selectedImage && selectedImage.id);
    if (!targetAssetId) return;
  
    let data = {
      id: targetAssetId,
      integerId: props.selectedProjectData && props.selectedProjectData.integerId,
      assetCategory: props.selectedSubCategories && props.selectedSubCategories.assetCategory,
      asinList: asinList || (selectedImage && selectedImage.asinList) || '',
      assetIdentifier:
        (props.selectedProjectData && (
          typeof props.selectedProjectData.brand === 'string'
            ? props.selectedProjectData.brand
            : (props.selectedProjectData.brand && props.selectedProjectData.brand.brand) || props.selectedProjectData.brandName
        )) || (selectedImage && selectedImage.assetIdentifier) || '',
      projectId: props.selectedProjectData && props.selectedProjectData.projectId,
      subCategoryId: props.selectedSubCategories && props.selectedSubCategories.id,
      destinationCategoriesId: destinationCategories || (selectedImage && selectedImage.destinationCategoriesId),
      destinationSubCategoriesId: destinationSubCategories || (selectedImage && (selectedImage.destinationSubCategoriesId || selectedImage.destinationSubCategories)),
      projectName: props.selectedProjectData && props.selectedProjectData.projectName
    };
  
    ValidateMoveAssetService(props.token, data).then((res) => {
      if (!res) return;
  
      if (res.error) {
        setErrorPopupMessage(res.message);
        setErrorPopupOpen(true);
        return;
      }
  
      // Validation Success
      setIsMoveAssetsPopup(true);
    });
  };
  const handleMoveToAssetgallery = () => {
    setIsMoveAssetsPopup(false);
    const targetAssetId = actionAssetId || (selectedImage && selectedImage.id);
    if (!targetAssetId) return;

    let data = {
      id: targetAssetId,
      integerId: props.selectedProjectData && props.selectedProjectData.integerId,
      assetCategory: props.selectedSubCategories && props.selectedSubCategories.assetCategory,
      asinList: asinList || (selectedImage && selectedImage.asinList) || '',
      assetIdentifier:
        (props.selectedProjectData && (
          typeof props.selectedProjectData.brand === 'string'
            ? props.selectedProjectData.brand
            : (props.selectedProjectData.brand && props.selectedProjectData.brand.brand) || props.selectedProjectData.brandName
        )) || (selectedImage && selectedImage.assetIdentifier) || '',
      projectId: props.selectedProjectData && props.selectedProjectData.projectId,
      subCategoryId: props.selectedSubCategories && props.selectedSubCategories.id,
      destinationCategoriesId: destinationCategories || (selectedImage && selectedImage.destinationCategoriesId),
      destinationSubCategoriesId: destinationSubCategories || (selectedImage && (selectedImage.destinationSubCategoriesId || selectedImage.destinationSubCategories)),
      projectName: props.selectedProjectData && props.selectedProjectData.projectName
    };
  
    FilesMoveToAssetGalleryService(props.token, data).then((res) => {
      if (!res) return;
  
      // Backend Error → Show Popup
      if (res.error) {
        setErrorPopupMessage(res.message);
        setErrorPopupOpen(true);
        return;
      }
  
      //  Success
      if (res.fileList) {
        props.setFileList(res.fileList.fileList);
        props.setAssetsStatusCount(res.fileList.assetStatusCount);
        onClose();
        notify.NotifySuccess(
          "The asset has been moved to asset gallery successfully."
        );
      }
    });
  };
  
  const handleCloseAnnotationPopup = () => {
    // Check if any annotation has been newly added or edited
    const hasUnsavedChanges = stagedAnnotations.some(ann => ann.isNew || ann.isEdited);

    if (hasUnsavedChanges) {
      setIsCloseConfirmOpen(true);
    } else {
      setAnnotationsPopup(false); 
    }
  };

  const handleReplyAnnotation = (res) => {
    if (res && res.localOnly) {
      setStagedAnnotations((prev) =>
        (prev || []).map((ann) =>
          ann.id === res.annotationId
            ? { ...ann, replies: [...(ann.replies || []), res.reply] }
            : ann
        )
      );
      return;
    }

    const updatedFileList = res && res.fileList && res.fileList.fileList;
    if (!updatedFileList && !(res && res.annotationReplies)) return;

    if (updatedFileList) {
      props.setFileList(updatedFileList);
    }
    const versionOverride = selectedVersionAsset ? actionAssetId : null;
    const syncedAnnotations = updatedFileList
      ? syncAnnotationsFromFileList(updatedFileList, versionOverride)
      : [];

    setStagedAnnotations((prev) => {
      if (updatedFileList) {
        return mergeStagedAfterReplySync(prev, syncedAnnotations);
      }
      return (prev || []).map((ann) => ({
        ...ann,
        replies: (res.annotationReplies && (res.annotationReplies[ann.id] || res.annotationReplies[String(ann.id)])) || ann.replies || [],
      }));
    });
    if (syncedAnnotations.length) {
      setOriginalAnnotations(JSON.parse(JSON.stringify(
        syncedAnnotations.map(({ isNew, isEdited, ...ann }) => ({
          ...ann,
          replies: Array.isArray(ann.replies) ? ann.replies : [],
        }))
      )));
    }
    if (res.fileList && res.fileList.assetStatusCount) {
      props.setAssetsStatusCount(res.fileList.assetStatusCount);
    }
  };

  const handleDiscardAndClose = () => {
    setIsCloseConfirmOpen(false);
    setAnnotationsPopup(false);
  };
  
  const handleSaveAndClose = () => {
    setIsCloseConfirmOpen(false);
    if (!hasUnsavedChanges || isSaving) {
      setAnnotationsPopup(false);
      return;
    }
    setIsSaving(true);

    const pendingReplies = collectPendingReplies(stagedAnnotations);
    const annotationsToSave = stagedAnnotations.map(({ isNew, isEdited, replies, ...ann }) => ann);

    let data = {
      integerId: props.selectedProjectData.integerId,
      assetCategory: props.selectedSubCategories.assetCategory,
      asinList: props.selectedASIN,
      assetIdentifier: props.selectedProjectData.brand,
      projectId: props.selectedProjectData.projectId,
      subCategoryId: props.selectedSubCategories.id,
      assetId: actionAssetId,
      annotations: annotationsToSave,
    };

    const flushPendingReplies = (assetsAnnotationsId) => {
      if (!pendingReplies.length) return Promise.resolve(null);
      return pendingReplies.reduce(
        (chain, pending) => chain.then(() => AssetAnnontationsReplyService(props.token, {
          id: pending.annotationId,
          comment: pending.comment,
          assetId: actionAssetId,
          assetsAnnotationsId: assetsAnnotationsId || null,
          integerId: props.selectedProjectData.integerId,
          assetCategory: props.selectedSubCategories.assetCategory,
          assetIdentifier: props.selectedProjectData.brand,
          projectId: props.selectedProjectData.projectId,
          subCategoryId: props.selectedSubCategories.id,
          asinList: props.selectedASIN,
        })),
        Promise.resolve()
      );
    };

    SaveAssetsAnnonationsService(props.token, data).then((res) => {
      if (res) {
        const newFileList = res.fileList && res.fileList.fileList;
        const versionOverride = selectedVersionAsset ? actionAssetId : null;
        const updatedParent = newFileList && newFileList.find((file) => file.id === selectedImage.id);
        const versionMatch = versionOverride && updatedParent
          ? (updatedParent.versionAssets || []).find((v) => String(v.id) === String(versionOverride))
          : null;
        const assetsAnnotationsId = versionMatch
          ? versionMatch.assetsAnnotationsId
          : (updatedParent && updatedParent.assetsAnnotationsId);

        return flushPendingReplies(assetsAnnotationsId).then(() => {
          if (newFileList) {
            props.setFileList(newFileList);
          }
          if (res.fileList && res.fileList.assetStatusCount) {
            props.setAssetsStatusCount(res.fileList.assetStatusCount);
          }
          setAnnotationsPopup(false);
        });
      }
      return null;
    }).catch(error => {
      console.error("Failed to save annotations:", error);
    }).finally(() => {
      setIsSaving(false);
    });
  };



  const handleDeleteAndSaveAnnotation = (annotationId) => {
    const updatedAnnotations = stagedAnnotations.filter(ann => ann.id !== annotationId);

    setStagedAnnotations(updatedAnnotations);
    setOriginalAnnotations(updatedAnnotations.map(({ isNew, isEdited, replies, ...ann }) => ({
      ...ann,
      replies: Array.isArray(replies) ? replies : [],
    })));

    const annotationsToSave = updatedAnnotations.map(({ isNew, isEdited, replies, ...ann }) => ann);

    let data = {
      integerId: props.selectedProjectData.integerId,
      assetCategory: props.selectedSubCategories.assetCategory,
      asinList:props.selectedASIN,
      assetIdentifier: props.selectedProjectData.brand,
      projectId: props.selectedProjectData.projectId,
      subCategoryId: props.selectedSubCategories.id,
      assetId: actionAssetId,
      annotations: annotationsToSave
    };

    SaveAssetsAnnonationsService(props.token, data).then((res) => {
      if (res) {
        const newFileList = res.fileList && res.fileList.fileList;
        if (newFileList) {
          props.setFileList(newFileList);
          const versionOverride = selectedVersionAsset ? actionAssetId : null;
          const syncedAnnotations = syncAnnotationsFromFileList(newFileList, versionOverride);
          const cleanAnnotations = (syncedAnnotations || []).map(({ isNew, isEdited, ...ann }) => ({
            ...ann,
            replies: Array.isArray(ann.replies) ? ann.replies : [],
          }));
          setStagedAnnotations(cleanAnnotations);
          setOriginalAnnotations(JSON.parse(JSON.stringify(cleanAnnotations)));
        }
      }
    }).catch(error => {
      console.error("Failed to delete and save annotation:", error);
    });
  };
  // Compare annotation content only (ignore replies / local flags) for unsaved detection
  const normalizeAnnotationsForCompare = (list) =>
    (Array.isArray(list) ? list : [])
      .filter((ann) => ann && ann.id)
      .map(({ isNew, isEdited, replies, ...ann }) => ann)
      .sort((a, b) => String(a.id).localeCompare(String(b.id)));
  const hasUnsavedChanges =
    JSON.stringify(normalizeAnnotationsForCompare(originalAnnotations)) !==
    JSON.stringify(normalizeAnnotationsForCompare(stagedAnnotations));
    const isMappedAsset =
    asinList &&
    asinList !== "Unmapped Assets";
  return (
  <>
      {/* Vertical Scroll Column */}
      <Col md={2} className="vertical-scroll-column">
        {file && file.map((parentFile) => {
          const versions = parentFile.versionAssets || [];
          const isParentSelected =
            selectedImage && String(selectedImage.id) === String(parentFile.id);
          const isOriginalSelected = isParentSelected && !selectedVersionId;

          const activeFilter = props.statusFilter || 'All';
          const showParent = activeFilter === 'All' ||
            matchesGraphicsQAStatus(parentFile.statusText, activeFilter);
          const filteredVersions = activeFilter === 'All'
            ? versions
            : versions.filter((v) => matchesGraphicsQAStatus(v.statusText, activeFilter));

          // If nothing matches in this group, skip rendering entirely
          if (!showParent && filteredVersions.length === 0) return null;

          return (
            <div key={parentFile.id} className="graphics-qa-version-bunch">
              {showParent && renderSidebarAssetCard(parentFile, {
                isSelected: isOriginalSelected,
                onClick: () => handleImageClick(parentFile),
                label: versions.length > 0 ? 'Original' : '',
                amazonPosition: parentFile.amazonPosition,
              })}

              {filteredVersions.map((version) => {
                const isVersionSelected =
                  isParentSelected &&
                  String(selectedVersionId) === String(version.id);

                return (
                  <div key={version.id}>
                    {renderSidebarAssetCard(version, {
                      isSelected: isVersionSelected,
                      onClick: (event) => handleVersionSidebarClick(parentFile, version, event),
                      label: `V${version.revision || '-'}`,
                      isVersion: true,
                      amazonPosition: parentFile.amazonPosition,
                    })}
                  </div>
                );
              })}
            </div>
          );
        })}
      </Col>

      {/* Selected Image Column */}
      <Col md={10}>
        <Card className="p-3" style={{ position: 'relative', minHeight: '400px' }}>
          <button className="card-close-button" title="Close" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
          <Row>
          {!selectedImage && (
            <Col md={12} className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
              <h4 className="text-muted">No Assets Found!</h4>
            </Col>
          )}
          {selectedImage && (
            <Col md={6}>
              <Card className="mb-3 p-3 qa-selected-image">
                <div
                  className={`grahics-qa-status-dot-selected ${displayImage && displayImage.statusText ? displayImage.statusText : ''}`}
                  style={{ backgroundColor: (displayImage && displayImage.statuscolor) || 'transparent', cursor: 'pointer' }}
                  title={(displayImage && displayImage.statusText) || (selectedVersionAsset ? 'Version' : '')}
                ></div>
                {/* <img
                  src={selectedImage.filePath}
                  alt={selectedImage.actualFileName}
                  className="grahics-qa-asset-img-selected"
                /> */}
                <PhotoDisplay
                key={selectedVersionId || selectedImage.id}
                  image={displayImage}
                  annotations={activeAnnotations}
                />
                <div className="graphics-qa-id d-flex align-items-center justify-content-between mt-1">
                  <div className="d-flex align-items-center flex-grow-1">
                    <span className="mr-3">
                      <b>{selectedVersionAsset ? selectedVersionAsset.id : selectedImage.id}</b>
                    </span>

                    {isClickEditName ? (
                      <>
                        <Input
                          className="w-100 mr-2"
                          type="text"
                          value={editedFileName}
                          onChange={(e) => setEditedFileName(e.target.value)}
                        />
                        <Input
                          type="text"
                          value={amazonPosition}
                          placeholder="#"
                          onChange={(e) => setAmazonPosition(e.target.value)}
                          className="w-25 mr-1"
                          style={{ display: 'inline-block' }}
                        />
                      </>
                    ) : (
                      selectedImage && (
                      <>
                        <h6 title={displayImage.actualFileName} className="comment-paragraph-graphics-qa mb-0 mr-4">
                          <b>{displayImage.actualFileName}</b>
                        </h6>
                        {isVersionAssetsOpen ? (
                          <span className="d-flex align-items-center" title="Amazon Position">
                            <b style={{ color: '#B01A00' }}>#</b>
                            <Input
                              type="text"
                              value={amazonPosition === '0' ? '' : (amazonPosition || '')}
                              placeholder=""
                              onChange={(e) => setAmazonPosition(e.target.value)}
                              className="ml-1"
                              style={{ width: '70px', height: '30px', color: '#B01A00', fontWeight: 'bold' }}
                            />
                          </span>
                        ) : selectedImage.amazonPosition ? (
                          <span title="Amazon Position">
                            <b id="amazonPosition" style={{ color: '#B01A00' }}>
                              #{selectedImage.amazonPosition}
                            </b>
                          </span>
                        ) : (
                          <b id="amazonPosition" style={{ color: '#B01A00' }}>#</b>
                        )}
                      </>
                      )
                    )}
                  </div>
                  <div className="d-flex align-items-center">
                    {isClickEditName ? (
                      <>
                        <button
                          title="Save"
                          className="info-button-background-none"
                          onClick={handleSaveRename}
                          disabled={!editedFileName}
                        >
                          <img className="button-img-background-assets" src={EditDoneIcon} alt="Save" />
                        </button>
                        <button
                          title="Cancel"
                          className="info-button-background-none"
                          style={{ marginLeft: '-4px' }}
                          onClick={() => {
                            setIsClickEditName(false);
                            setEditedFileName((displayImage && displayImage.actualFileName) || selectedImage.actualFileName);
                            setAmazonPosition(selectedImage.amazonPosition || '');
                          }}
                        >
                          <img className="button-img-background-assets" src={EditCloseIcon} alt="Cancel" />
                        </button>
                      </>
                    ) : (
                      (![4, 5, 12, 14].includes(Number(selectedStatus)) || isVersionFileSelected) && (
                      <button
                        title="Edit"
                        className="info-button-background-none ml-2"
                          onClick={() => {
                          setEditedFileName((displayImage && displayImage.actualFileName) || '');
                          setAmazonPosition(selectedImage.amazonPosition || '');
                          setIsClickEditName(true);
                        }}
                      >
                        <img className="button-img-background-assets p-1" src={Rename} alt="Edit" />
                      </button>)
                    )}
                    {![4, 5,14].includes(displayStatusId) || isVersionFileSelected ? ( //'4'=Sent for Approval / '5'=Approved by Client / '3' =Paused/'6'-Submitted
                    <button
                        title="Add Annotations"
                        className="info-button-background-none ml-2"
                        onClick={() => { handleAnnotaionPopup() }}
                        >
                    <img src={AnnotationIcon}/>
                    </button>) : null}
                    <button
                      onClick={() => {
                        const fileToDownload = selectedVersionAsset || displayImage || selectedImage;
                        handleDownloadImage(
                          fileToDownload.filePath,
                          "DownloadeImage",
                          fileToDownload.actualFileName || fileToDownload.fileName
                        );
                      }}
                      className='info-button-background-none ml-2'
                      title='Download'
                    >
                      <img
                        className={`p-1 ${downloadAction == "DownloadeImage"
                          ? 'button-img-background-download-inprogress'
                          : 'button-img-background-download'}`}
                        src={Download}
                        alt='not found'
                      />
                    </button>
                    {downloadAction === "DownloadeImage" && <span className="ml-1">Downloading</span>}
                  </div>
                </div>
               
                <div className="d-flex justify-content-between align-items-center mt-1">
                    <div className="d-flex align-items-center">
                        <h6 className="mb-0 mr-3">
                            {displayImage.fileSize}
                        </h6>

                        <p className="mb-0">
                            Last Modified on&nbsp;
                            <b>{displayImage.updatedAt}</b>
                        </p>
                    </div>

                    {[1, 2, 3, 12].includes(
                        Number(
                            versionAssets && versionAssets.length > 0
                                ? versionAssets[versionAssets.length - 1].status
                                : (selectedImage && selectedImage.status)
                        )
                    ) && (
                        <Button
                            className="btn-send-approval"
                            onClick={() => {
                              const nextOpen = !isVersionAssetsOpen;
                              if (nextOpen) {
                                setAmazonPosition(selectedImage.amazonPosition || '');
                              }
                              setIsVersionAssetsOpen(nextOpen);
                            }}
                        >
                            Upload Version
                        </Button>
                    )}
                </div>
                <div className='d-flex justify-content-between mb-2'>
                {versionAssets.length > 0 ? (
                  <div className="d-flex align-items-center mt-2 flex-wrap">
                    <label className="mb-0 mr-3"><b>Versions:</b></label>
                    <div className="d-flex flex-wrap">
                      {/* Original Thumbnail */}
                      <div 
                        className={`text-center mr-3`}
                        onClick={() => { setSelectedVersionId(''); setIsClickEditName(false); }}
                        style={{ cursor: 'pointer', position: 'relative' }}
                      >
                        <div 
                          style={{
                            width: '12px', height: '12px', borderRadius: '50%', 
                            backgroundColor: selectedImage.statuscolor || 'transparent',
                            position: 'absolute', top: '-4px', right: '-4px', zIndex: 1, border: '2px solid #fff'
                          }} 
                          title={selectedImage.statusText}
                        ></div>
                        <img 
                          src={selectedImage.filePath} 
                          alt="Original" 
                          style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '6px', border: !selectedVersionId ? '3px solid #007bff' : '1px solid #ccc' }} 
                        />
                        <p style={{ fontSize: '11px', margin: '2px 0 0 0', fontWeight: !selectedVersionId ? 'bold' : 'normal' }}>Original</p>
                      </div>

                      {/* Version Thumbnails */}
                      {versionAssets.map((version) => (
                        <div 
                          key={version.id}
                          className={`text-center mr-3`}
                          onClick={() => { setSelectedVersionId(version.id); setIsClickEditName(false); }}
                          style={{ cursor: 'pointer', position: 'relative' }}
                        >
                          <div 
                            style={{
                              width: '12px', height: '12px', borderRadius: '50%', 
                              backgroundColor: version.statuscolor || 'transparent',
                              position: 'absolute', top: '-4px', right: '-4px', zIndex: 1, border: '2px solid #fff'
                            }} 
                            title={version.statusText}
                          ></div>
                          <img 
                            src={version.filePath} 
                            alt={`V${version.revision}`} 
                            style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '6px', border: String(selectedVersionId) === String(version.id) ? '3px solid #007bff' : '1px solid #ccc' }} 
                          />
                          <p style={{ fontSize: '11px', margin: '2px 0 0 0', fontWeight: String(selectedVersionId) === String(version.id) ? 'bold' : 'normal' }}>V{version.revision || '-'}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
               
                  </div>
              
                  

                  {isVersionAssetsOpen && (
                    <div className="p-4 dotted-box-upload-product">
                      <p className="mb-2" style={{ fontSize: "13px" }}>Supported File (png,jpg,jpeg)</p>
                      <div
                        onDrop={(e) => {
                          e.preventDefault();
                          setDraggingVersion(false);
                          const files = Array.from(e.dataTransfer.files || []);
                          const allowedExtensions = ['jpg', 'jpeg', 'png'];
                          const validFiles = files.filter((file) =>
                            allowedExtensions.includes((file.name.split('.').pop() || '').toLowerCase())
                          );
                          const invalidFiles = files.filter((file) =>
                            !allowedExtensions.includes((file.name.split('.').pop() || '').toLowerCase())
                          );
                          if (invalidFiles.length > 0) {
                            setAlertMessageVersion(`Invalid file(s) detected: ${invalidFiles.map((file) => file.name).join(', ')}. Only png, jpg, and jpeg files are allowed.`);
                          } else {
                            setAlertMessageVersion('');
                          }
                          if (validFiles.length > 0) {
                            setSelectedVersionImageFiles((prevFiles) => [...prevFiles, ...validFiles]);
                          }
                        }}
                        onDragOver={(e) => {
                          e.preventDefault();
                          setDraggingVersion(true);
                        }}
                        onDragEnter={(e) => {
                          e.preventDefault();
                          setDraggingVersion(true);
                        }}
                        onDragLeave={(e) => {
                          e.preventDefault();
                          setDraggingVersion(false);
                        }}
                      >
                        <label
                          htmlFor="versionAssetFileInput"
                          className={`custom-brand-file-input text-center uploadfile ${
                            draggingVersion ? "dragging" : ""
                          }`}
                        >
                          <h5>
                            <FontAwesomeIcon
                              icon={faCloudUploadAlt}
                              style={{ fontSize: "30px" }}
                            />
                          </h5>
                          <h5>Drag &amp; Drop Files </h5>
                          <h5>OR</h5>
                          <input
                            type="file"
                            id="versionAssetFileInput"
                            className="custom-brand-file"
                            accept=".png,.jpg,.jpeg"
                            multiple
                            onChange={(e) => {
                              const files = Array.from(e.target.files || []);
                              const allowedExtensions = ['jpg', 'jpeg', 'png'];
                              const validFiles = files.filter((file) =>
                                allowedExtensions.includes((file.name.split('.').pop() || '').toLowerCase())
                              );
                              const invalidFiles = files.filter((file) =>
                                !allowedExtensions.includes((file.name.split('.').pop() || '').toLowerCase())
                              );
                              if (invalidFiles.length > 0) {
                                setAlertMessageVersion(`Invalid file(s) detected: ${invalidFiles.map((file) => file.name).join(', ')}. Only png, jpg, and jpeg files are allowed.`);
                              } else {
                                setAlertMessageVersion('');
                              }
                              if (validFiles.length > 0) {
                                setSelectedVersionImageFiles((prevFiles) => [...prevFiles, ...validFiles]);
                              }
                              e.target.value = '';
                            }}
                            style={{ display: "none" }}
                          />
                          <Button
                            onClick={() =>
                              document.getElementById("versionAssetFileInput").click()
                            }
                            style={{ background: "#B2A1FF" }}
                          >
                            Browse Files
                          </Button>
                        </label>
                        <p style={{ color: "red" }}>{alertMessageVersion}</p>
                        <p style={{ fontSize: "13px" }}>Attached File List</p>
                        <ul style={{ color: "green", fontSize: "13px" }}>
                          {selectedVersionImageFiles.length > 0 ? (
                            selectedVersionImageFiles.map((file, index) => (
                              <li key={`${file.name}-${index}`}>
                                {file.name}
                                <button
                                  className="btn"
                                  onClick={() =>
                                    setSelectedVersionImageFiles((prevFiles) =>
                                      prevFiles.filter((_, fileIndex) => fileIndex !== index)
                                    )
                                  }
                                >
                                  <FontAwesomeIcon
                                    color="red"
                                    size="15px"
                                    icon={faWindowClose}
                                  />
                                </button>
                              </li>
                            ))
                          ) : (
                            <li>No files attached</li>
                          )}
                        </ul>
                      </div>
                      <div className="d-flex justify-content-center m-3">
                        <Button
                          className="btn-background-color-Proceed-gallery"
                          disabled={selectedVersionImageFiles.length < 1 || loadingVersionButton}
                          onClick={handleSaveVersionAssets}
                        >
                          {loadingVersionButton ? 'Submitting' : 'Submit'}
                        </Button>
                      </div>
                    </div>
                  )}

                <p className="mb-1" style={{ fontSize: "14px" }}>
                  {/* <b>Destination Category :</b> */}
                  <Label><strong>Destination Category :</strong></Label>
                </p>
                    {[4, 12,14].includes(displayStatusId) ? (    //'4'=Sent for Approval / '14'=Moved to Asset Gallery /'12'-Re-work
                    <div>
                      <select
                        className="form-control"
                        disabled
                        value={String(destinationSubCategories || currentDestinationId || "")}
                      >
                        <option value="">--Destination Category--</option>
                        {props.existingSubCategories &&
                          props.existingSubCategories.map((subCategories) => (
                            <option key={subCategories.id} value={String(subCategories.id)}>
                              {subCategories.subCategoryName}
                              {" "}
                        ({subCategories.assetCategory__categoryName})
                            </option>
                          ))}
                      </select>
                    </div>
                  ) : (
                   
                    <select
                      className="form-control"
                      value={String(destinationSubCategories || currentDestinationId || '')}
                      onChange={(e)=>{handleDestinationSubCategories(e);}}
                    >
                      <option value="">--Destination Category--</option>
                      {props.existingSubCategories &&
                        props.existingSubCategories.map((subCategories) => (
                          <option key={subCategories.id} value={String(subCategories.id)}>
                            {subCategories.subCategoryName}
                            {" "}
                        ({subCategories.assetCategory__categoryName})
                          </option>
                        ))}
                    </select>
                   
                   
                  )}
                <div className='d-flex mt-2'>
                    <Col md={7} className='mt-2'>
                        <p className="mb-1" style={{ fontSize: "14px" }}>
                          <b>Asins List :</b>
                        </p>
                        <div
                          style={{
                            maxHeight: "105px",
                            overflowY: "auto",
                          }}
                        >
                          {(Array.isArray(asinList)
                            ? asinList
                            : typeof asinList === 'string'
                            ? asinList.split(',')
                            : []
                          ).map((asin, index) => (
                            <div key={index}>{asin}</div>
                          ))}
                        </div>
                      </Col>
                      {isApprovedGraphics && (   //'5'=Approved by Client or statusText=Approved
              
                    <Col md={5} className='mt-3'>
                      <Button
                        className="btn-background-color w-100 mb-2"
                        onClick={() => { handleSelectProduct() }}
                      >
                        Map ASINs
                        <img className='ml-2 mb-1' src={NewTaskIcon} style={{ height: '18px' }} />
                      </Button>
                      <Button
                        className="w-100"
                        onClick={
                          isMappedAsset
                              ? handleMoveAsset
                              : handleMoveToAssetgallery
                      }
                        style={{ backgroundColor: '#80ffbc', color: '#243837' }}
                      >
                         {isMappedAsset ? "Move Asset" : "Move to Asset Gallery"}
                        <img className='ml-2 mb-1' src={MoveToAssetGallery} style={{ height: '18px' }} />
                      </Button>
                       {/* {![4, 5].includes(selectedStatus) && (    //'4'=Sent for Approval / '5'=Approved by Client / '3' =Paused/'6'-Submitted
                       <Button
                       className="btn-background-color w-100 mt-2 pl-1 pr-0"
                       onClick={() => { handleAnnotaionPopup() }}
                     >
                       Add Annotations
                       <img className='ml-1 mb-1' src={Annotation}  />
                     </Button>)} */}
                    </Col>)}
                </div> 

                <div className="box-border-upload-product mt-3">
                  <p>
                    Editable Graphics Files
                    {selectedFileObject.originalGA && selectedFileObject.originalGA !== "" ? (
                      <span className="ml-1" style={{ color: "green" }}>Available</span>
                    ) : (
                      <span className="ml-1" style={{ color: "red" }}>Not Available</span>
                    )}
                    <button
                      className="info-button-background-none float-right"
                      onClick={() => {
                        setIsDropdownOpen(!isDropdownOpen);
                        setIsUploadAiFIlesUi(false);
                      }}
                    >
                      {isDropdownOpen ? (
                        <FontAwesomeIcon icon={faAngleUp} />
                      ) : (
                        <FontAwesomeIcon icon={faAngleDown} />
                      )}
                    </button>
                  </p>

                  {isDropdownOpen && (
                    <div>
                      {selectedFileObject.originalGA && selectedFileObject.originalGA !== "" ? (
                        <>
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="file-name mb-0">
                              <b>{selectedFileObject.originalGA[0].actualFileName}</b>
                            </h6>
                            <button
                              onClick={() =>
                                handleDownloadImage(
                                  selectedFileObject.originalGA[0].filePath,
                                  "DownloadGraphic"
                                )
                              }
                              className="info-button-background-none"
                              title="Download"
                            >
                              <img
                                className={`p-1 ${
                                  downloadAction === "DownloadGraphic"
                                    ? "button-img-background-download-inprogress"
                                    : "button-img-background-download"
                                }`}
                                src={Download}
                                alt="Download"
                              />
                            </button>
                          </div>
                          {downloadAction === "DownloadGraphic" ? <span>Downloading</span> : ""}

                          <div className="d-flex justify-content-between mt-2">
                            <h6 className="mb-0">{selectedFileObject.originalGA[0].fileSize}</h6>
                            <p className="mb-0">
                              Last Modified on <b>{selectedFileObject.originalGA[0].updatedAt}</b>
                            </p>
                          </div>
                        </>
                      ) : (
                        ![4, 5, 12,14].includes(displayStatusId) && (  //'4'=Sent for Approval / '5'=Approved by Client / '3'-Paused/'6'-Submitted /'12'-Re-work
                          isUploadAiFIlesUi ? (
                            <div className="p-4 ml-4 dotted-box-upload-product">
                              <select
                                className="form-control w-100 mb-3"
                                onChange={(e) => {
                                  handleLinkfile(e.target.value);
                                }}
                              >
                                <option value={""}>--Select Existing File--</option>
                                {props.allOriginalFiles &&
                                  props.allOriginalFiles.map((file) => (
                                    <option value={file.id} key={file.id}>
                                      {file.actualFileName} &nbsp;&nbsp; ({file.createdAtGraphics})
                                    </option>
                                  ))}
                              </select>

                              {handleLinkFile ? (
                                ""
                              ) : (
                                <>
                                  <h5 className="text-center">OR</h5>
                                  <div
                                    onDrop={handleGADrop}
                                    onDragOver={handleGADragOver}
                                    onDragEnter={handleGADragEnter}
                                    onDragLeave={handleGADragLeave}
                                  >
                                    <label
                                      htmlFor="graphicFileInput"
                                      className={`custom-brand-file-input text-center uploadfile ${
                                        dragging ? "dragging" : ""
                                      }`}
                                    >
                                      <h5>
                                        <FontAwesomeIcon
                                          icon={faCloudUploadAlt}
                                          style={{ fontSize: "30px" }}
                                        />
                                      </h5>
                                      <h5>Drag &amp; Drop Files </h5>
                                      <h5>OR</h5>
                                      <input
                                        type="file"
                                        id="graphicFileInput"
                                        className="custom-brand-file"
                                        onChange={handleGraphicFileChange}
                                        style={{ display: "none" }}
                                      />
                                      <Button
                                        onClick={() =>
                                          document.getElementById("graphicFileInput").click()
                                        }
                                        style={{ background: "#B2A1FF" }}
                                      >
                                        Browse Files
                                      </Button>
                                    </label>
                                    <p style={{ color: "red" }}>{alertMessageAi}</p>
                                    <p style={{ fontSize: "13px" }}>Attached File List</p>
                                    <ul style={{ color: "green", fontSize: "13px" }}>
                                      {selectedGraphicFiles.length > 0 ? (
                                        selectedGraphicFiles.map((file, index) => (
                                          <li key={index}>
                                            {file.name}
                                            <button
                                              className="btn"
                                              onClick={() => handleGraphicRemoveFile(file)}
                                            >
                                              <FontAwesomeIcon
                                                color="red"
                                                size="15px"
                                                icon={faWindowClose}
                                              />
                                            </button>
                                          </li>
                                        ))
                                      ) : (
                                        <li>No files attached</li>
                                      )}
                                    </ul>
                                  </div>
                                </>
                              )}

                              <div className="d-flex justify-content-center m-3">
                                <Button
                                  className="btn-background-color-Proceed-gallery"
                                  disabled={!(active && !loadingButton) || alertMessageAi}
                                  onClick={() => handleSubmitFile()}
                                >
                                  {loadingButton ? "Submitting" : "Submit"}
                                </Button>
                              </div>
                            </div>
                          ) : (
                            <div className="text-center mt-3">
                              <h6
                                onClick={() => setIsUploadAiFIlesUi(true)}
                                style={{ textDecoration: "underline", cursor: "pointer" }}
                              >
                                Upload File
                                <img className="ml-2" src={UploadButton_Dark} alt="Upload" />
                              </h6>
                            </div>
                          )
                        )
                      )}
                    </div>
                  )}
                </div>


                <div className="d-flex justify-content-between align-items-center mt-3">
                {canSignOffOrDelete && (
                  <Button
                    onClick={() => {
                      setFileForDelete(displayImage || selectedImage);
                      setIsDeletePopUpOpen(true);
                      setIsDeleteConfirmPopUpOPen(true);
                    }}
                    className="delete-button-background-none mt-1"
                  >
                    <FontAwesomeIcon icon={faTrash} /> Delete
                  </Button>
                )}

                  <div className="d-flex">
                    {[1, 2, 3].includes(displayStatusId) && (
                      <Button className="pause-button mr-2" onClick={() => handleChangeStatus('PauseResume')}>
                        {displayStatusId === 3 ? 'Resume' : 'Pause'}
                      </Button>
                    )}
                    {[1, 2].includes(displayStatusId) &&
                      canSignOffOrDelete &&
                      props.projectPermissions &&
                      props.projectPermissions.ProjectAssetsGraphicsQA_MarkReady && (
                        <Button
                          className="btn-send-approval"
                          onClick={() => {
                            setConfrimationForSubmition(true);
                          }}
                        >
                          Sign Off
                        </Button>
                      )}
                  </div>

                </div>
              </Card>
            </Col>
           )}
            {/* Notes Column */}
            {selectedImage && (
            <Col md={6}>
            {selectedImage.statusText!=='Re-Work'?
            <>
              <div className="mt-4 ml-3" style={{ width: '93%' }}>
            <ReactQuill
                          theme={'snow'}
                          modules={Editor.modules}
                          formats={Editor.formats}
                          value={note}
                          onChange={handleQuillChange}
                          bounds={'.quill-prod'}
                          placeholder='Add Your Comments Here' />
                    </div>
                      <div className="p-3 w-100 d-flex justify-content-end">
                          <Button
                              className="btn-background-color"
                              onClick={() => addCMAssetChats()}
                              disabled={!note}
                          >
                              Add Note
                          </Button>
                      </div>
            </>:""}
          
            <div className="p-3 comment-card">
                    <div className="comments-box scrollable-div p-0 overflow-auto">
                      {(noteList || []).length > 0 ? (
                        noteList.map((note, index) => (
                          <div key={index}>
                            <div
                              className={`d-flex p-2 ${
                                note.loggedInUser === 1 ? "justify-content-end" : "justify-content-start align-items-end"
                              }`}
                            >
                              <div className="d-flex align-items-start">
                                {/* <div className="p-1 user-short-name">{note.userShortName.toUpperCase()}</div> */}
                                {selectedImage.loggedInUser !==note.createdBy ?
                               <div className="p-1 user-short-name">{note.userShortName.toUpperCase()}</div>:''}
                                <p
                                  className={`p-2 mb-0 ${
                                    note.loggedInUser === 1 ? "chat-background-color-sent" : "chat-background-color"
                                  }`}
                                >
                                  <ReadMore htmlContent={note.message} maxLength={200} 
                                  onReadMoreClick={openNoteModal}/>
                                  <span className="float-right pt-1">{note.createdAt}</span>
                                </p>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <LoadingOverlay
                          active={loadScreen}
                          styles={{
                            overlay: (base) => ({
                              ...base,
                              background: "#f1f4f6",
                              opacity: 1,
                            }),
                            content: (base) => ({
                              ...base,
                              color: "#000",
                            }),
                          }}
                          spinner={<Loader active type="ball-pulse" />}
                          text="Loading chat details..."
                        >
                          <p className="text-muted px-2 mt-3">No Comments</p>
                        </LoadingOverlay>
                      )}
                    </div>
                    
                  </div>
                </Col>
            )}
      
              {/* Duplicate File Confirmation Popup */}
              <CustomModal
                header={'Duplicate File Warning'}
                isOpen={isDuplicatePopupOpen}
                toggle={() => setIsDuplicatePopupOpen(!isDuplicatePopupOpen)}
                size={"md"}
                className="curve-popup"
              >
                <div className="modal-body">
                  {(() => {
                    // Group duplicate files by filename and combine asset lists
                    const groupedFiles = duplicateFiles.reduce((acc, duplicate) => {
                      const fileName = duplicate.fileName;
                      if (!acc[fileName]) {
                        acc[fileName] = {
                          fileName: fileName,
                          assetList: []
                        };
                      }
                      if (duplicate.assetList && duplicate.assetList.length > 0) {
                        acc[fileName].assetList = [...acc[fileName].assetList, ...duplicate.assetList];
                      }
                      return acc;
                    }, {});
                    
                    const uniqueFiles = Object.values(groupedFiles);
                    
                    return uniqueFiles.map((fileData, index) => (
                      <div key={index} className="mb-2 modal-body">
                        <p>"{fileData.fileName}" already exists.</p>
                        {fileData.assetList && fileData.assetList.length > 0 && (
                          <div>
                            <p>The existing file is already mapped to the following assets : </p>
                            <div className="mb-3">
                            <strong>Asset List:</strong>
                            <ul className="mt-2">
                              {fileData.assetList.map((asset, assetIndex) => (
                                <li key={assetIndex}>
                                  Asset ID: {typeof asset === 'object' ? asset.id : asset} | Name: {typeof asset === 'object' ? asset.name : '(Asset Name)'}
                                </li>
                              ))}
                            </ul>
                          </div>
                          </div>
                        )}
                        
                        <p className='mt-3'>Do you want to replace it? Please note replace action will update mapping for existing assets.</p>
                       
                      </div>
                    ));
                  })()}
                  
                  <div className='mb-2 d-flex justify-content-end mr-2'>
                    <Button 
                      className="no-btn-background-color"  
                      onClick={() => handleDuplicateConfirmation(false)} 
                    >
                      No
                    </Button>   &nbsp;
                    <Button
                      className='btn-background-color'
                      onClick={() => handleDuplicateConfirmation(true)} 
                      style={{ marginLeft: "10px" }}
                    >
                      Yes
                    </Button>
                  </div>
                </div>
              </CustomModal>
            {/* Delete Confirmation Popup */}
            <CustomModal
                    isOpen={isDeleteConfirmPopUpOPen}
                    toggle={() => { setIsDeleteConfirmPopUpOPen(!isDeleteConfirmPopUpOPen); setFileForDelete(false); }}
                    size={"md"}
                    className="curve-popup"
                >
                    <Card className="curve-popup p-3 ">
                        <Row>
                            <Col md={12}>
                                <div>
                                    <h6>
                                        Are you sure you want to delete file?
                                    </h6>
                                </div>
                                <div className='mb-2'>
                                    <Button
                                        onClick={() => handleDeleteFile(fileForDelete,'false')}
                                        className='delete-button-background-none mt-1'
                                        disabled={!fileForDelete}>
                                        <FontAwesomeIcon icon={faTrash} /> &nbsp;
                                        Delete
                                    </Button> &nbsp;
                                    <Button
                                        onClick={() => { setFileForDelete(false); setIsDeleteConfirmPopUpOPen(!isDeleteConfirmPopUpOPen) }}
                                        className=' mt-1'>
                                        Cancel
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </CustomModal>
          </Row>
        </Card>
      </Col>
      {/* Add ASINs Modal */}
      <CustomModal
          header={
            <div className='d-flex'>
              Map ASINs for :  <b title= {selectedImage && selectedImage.actualFileName} className="comment-paragraph-ticket-history ml-2">{ selectedImage && selectedImage.actualFileName || ''}</b>
            </div>
          }
        isOpen={addProductsPopup}
        toggle={() => {
            setAddProductsPopup(!addProductsPopup)
        }}
        size={"lg"}
       className='my-task-custom-module'
      >

        <NewCMProductListScreen
        documentScreen={false}
        setAsinAssetCounts={props.setAsinAssetCounts}
        setAssetsStatusCount={props.setAssetsStatusCount}
        setSelectedASIN={props.setSelectedASIN}
        selectedProjectData= {props.selectedProjectData}
        selectedSubCategories ={props.selectedSubCategories}
         selectedImage={selectedImage}
         setFileListOfAssets={props.setFileListOfAssets}
         setSelectedImage={setSelectedImage}
         selectedStatus={selectedStatus}
         setSelectedStatus={setSelectedStatus}
        setAddProductsPopup={setAddProductsPopup}
        asinList={asinList}
        setAsinList={setAsinList}
        // setSelectedAsin={setSelectedAsin}
        action={false}
        productList={productList}
        />
        {/* <ViewProjectAsinList
              projectData={props.selectedProjectData}
              asinList={asinArray}
            /> */}
      
      </CustomModal>
        {/* Mark Ready Confirmation */}
        <CustomModal
        isOpen={annotationConfirmationPopup}
        toggle={() => setAnnotationConfirmationPopup(false)}
        size="md"
        className="curve-popup"
      >
        <Card className="curve-popup p-3">
          <Row>
            <Col md={12}>
              <div>
                <h6>Annotations have been added to this image. So this image cannot be signed off.</h6>
              </div>
            </Col>
          </Row>
        </Card>
      </CustomModal>
      <CustomModal
        isOpen={confrimationForSubmition}
        toggle={() => setConfrimationForSubmition(!confrimationForSubmition)}
        size="md"
        className="curve-popup"
      >
        <Card className="curve-popup p-3">
          <Row>
            <Col md={12}>
              <div>
                <h6>Are you sure you want to mark the asset ready for submission?</h6>
              </div>
              <div className='mb-2 d-flex justify-content-end mr-4 mt-4'>
              <Button
                 className=" no-btn-background-color mr-2"
                  onClick={() => setConfrimationForSubmition(false)}
                >
                  No
                </Button>
                &nbsp;
                <Button
                  className='btn-background-color'
                  onClick={() =>handleChangeStatus('SendforApproval')}
                >
                  Yes
                </Button>
               
                
              </div>
            </Col>
          </Row>
        </Card>
      </CustomModal>
      <CustomModal
        header={"Issue Description"}
        isOpen={isExpanded}
        toggle={() => setIsExpanded(!isExpanded)}
        size={"xl"}
        className="curve-popup"
        footer={
          <>
            <Button
              color={"link"}
              onClick={() =>
                setIsExpanded(!isExpanded)
              }
            >
              Cancel
            </Button>
          </>
        }
      >
        <p style={{ fontSize: "19px" }} className="issue-discription-set" dangerouslySetInnerHTML={{ __html: replaceNoteText }} />
        {/* <Label>{ticketHistoryText}</Label> */}
      </CustomModal>
           
  <CustomModal
    isOpen={annotationsPopup}
    toggle={handleCloseAnnotationPopup}
    size={"xl"}
    header={
      selectedImage ? (
        <div className="d-flex justify-content-between w-100 align-items-center">
          <p title={(displayImage && displayImage.actualFileName) || (selectedImage && selectedImage.actualFileName)} className="comment-paragraph-Project-asin-title mb-0">
            {(displayImage && displayImage.actualFileName) || (selectedImage && selectedImage.actualFileName)}
            {selectedVersionAsset && selectedVersionAsset.revision
              ? ` (V${selectedVersionAsset.revision})`
              : ' (Original)'}
          </p>
        </div>
      ) : null
    }
    className='my-task-custom-module'
  >
 {  !isAnnotationReadOnly ? (
        <Card>
          <div className="annotation-tools">
            <div className="tool-group">
              <span className="tool-label">Tools:</span>
              <div className="tool-options">
                {TOOLS.map(tool => (
                  <button
                    key={tool.type}
                    className={`tool-btn ${selectedTool === tool.type ? 'active' : ''}`}
                    onClick={() => setSelectedTool(tool.type)}
                  >
                    {tool.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="color-group">
              <span className="color-label">Colors:</span>
              <div className="color-options">
                {COLORS.map(color => (
                  <button
                    key={color}
                    className={`color-swatch ${selectedColor === color ? 'active' : ''}`}
                    style={{ backgroundColor: color }}
                    onClick={() => setSelectedColor(color)}
                  />
                ))}
              </div>
            </div>
            <Button
              className='btn-background-color ml-auto'
              onClick={handleSaveAllAnnotations}
              disabled={!hasUnsavedChanges || isSaving}
            >
              {isSaving ? 'Saving...' : 'Save All Changes'}
            </Button>
          </div>

          <AnnotationCanvas
            image={{
              ...displayImage,
              id: actionAssetId,
              assetsAnnotationsId: activeAssetsAnnotationsId,
              integerId: props.selectedProjectData && props.selectedProjectData.integerId,
              assetCategory: props.selectedSubCategories && props.selectedSubCategories.assetCategory,
              assetIdentifier: props.selectedProjectData && props.selectedProjectData.brand,
              projectId: props.selectedProjectData && props.selectedProjectData.projectId,
              asinList: props.selectedASIN || selectedImage.asinList || '',
              subCategoryId: props.selectedSubCategories && props.selectedSubCategories.id,
              assetSubCategory: props.selectedSubCategories && props.selectedSubCategories.id,
            }}
            selectedTool={selectedTool}
            selectedColor={selectedColor}
            onStageAnnotation={handleStageAnnotation}
            annotations={stagedAnnotations}
            onEditAnnotation={handleStageEdit}
            onDeleteAnnotation={handleStageDelete}
            onReplyAnnotation={handleReplyAnnotation}
          />
        </Card>
          ):
    <Card>
      <ReadOnlyAnnotationCanvas
        image={displayImage || selectedImage}
        selectedTool={selectedTool}
        selectedColor={selectedColor}
        onStageAnnotation={handleStageAnnotation}
        annotations={stagedAnnotations}
        onEditAnnotation={handleStageEdit}
        onDeleteAnnotation={handleStageDelete}
      />
      </Card>
       }
  </CustomModal>

      <CustomModal
        isOpen={isCloseConfirmOpen}
        toggle={() => setIsCloseConfirmOpen(false)}
        size={"md"}
        className="curve-popup"
        header={"Unsaved Changes"}
      >
        <Card className="curve-popup p-3 ">
          <Row>
            <Col md={12}>
              <div>
                <h6>Do you want to save changes before proceeding?</h6>
              </div>
              <div className='mb-2 mt-4 d-flex justify-content-end'>
                <Button
                  className=" no-btn-background-color mr-2"
                  onClick={handleDiscardAndClose}
                >
                  No
                </Button>
                <Button
                  className='btn-background-color'
                  onClick={handleSaveAndClose}
                >
                  Save
                </Button>
              </div>
            </Col>
          </Row>
        </Card>
      </CustomModal>
      <CustomModal
                header={"Comment"}
                isOpen={isExpanded}
                toggle={() => setIsExpanded(!isExpanded)}
                size={"xl"}
                className="curve-popup"
                footer={
                    <>
                        <Button
                            color={"link"}
                            onClick={() =>
                                setIsExpanded(!isExpanded)
                            }
                        >
                            Cancel
                        </Button>
                    </>
                }
            >
                <p style={{ fontSize: "19px" }} className="issue-discription-set" dangerouslySetInnerHTML={{ __html: expandedMessages || '' }} />
            </CustomModal>
            <CustomModal
              isOpen={errorPopupOpen}
              toggle={() => setErrorPopupOpen(false)}
              size="md"
              className="curve-popup"
              header="Action Required"
            >
              <Card className="curve-popup p-3">
                <Row>
                  <Col md={12}>
                    <p className="mb-2">{errorPopupMessage}</p>

                    <div className="d-flex justify-content-end mt-3">
                      <Button
                        className="btn-background-color"
                        onClick={() => setErrorPopupOpen(false)}
                      >
                        OK
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Card>
            </CustomModal>
            <CustomModal
              isOpen={isMoveAssetsPopup}
              toggle={() => setIsMoveAssetsPopup(false)}
              size="lg"
              className="curve-popup"
              header={
                (() => {
                    if (!asinList || asinList === "Unmapped Assets") {
                        return "Move Asset";
                    }
            
                    const asinString =
                        typeof asinList === "string"
                            ? asinList
                            : String(asinList);
            
                    return `Move Asset for ${asinString
                        .split(",")
                        .map((asin) => asin.trim())
                        .join(", ")}`;
                })()
            }
          >
              <Card className="curve-popup p-4 border-0">
           
                  <AmazonListingImageUpdatePopup
                    isMoveAssetsPopup={isMoveAssetsPopup}
                    setIsMoveAssetsPopup={setIsMoveAssetsPopup}
                    handleMoveToAssetgallery={handleMoveToAssetgallery}
                    asinList={asinList}
                    integerId={props.selectedProjectData.integerId}
                    replacementImage={{
                      url: (displayImage && displayImage.filePath) || (selectedImage && selectedImage.filePath),
                      fileName: (displayImage && displayImage.actualFileName) || (selectedImage && selectedImage.actualFileName),
                      assetId: actionAssetId
                  }}
                  moveToAssetGalleryData={{
                    id: actionAssetId || (selectedImage && selectedImage.id),
                    integerId: props.selectedProjectData.integerId,
                    assetCategory:
                        props.selectedSubCategories &&
                        props.selectedSubCategories.assetCategory,
                    asinList:
                        asinList ||
                        (selectedImage && selectedImage.asinList) ||
                        "",
                    assetIdentifier:
                        props.selectedProjectData &&
                        (
                            typeof props.selectedProjectData.brand === "string"
                                ? props.selectedProjectData.brand
                                : (
                                    props.selectedProjectData.brand &&
                                    props.selectedProjectData.brand.brand
                                ) ||
                                props.selectedProjectData.brandName
                        ),
                    projectId: props.selectedProjectData.projectId,
                    subCategoryId:
                        props.selectedSubCategories &&
                        props.selectedSubCategories.id,
                    destinationCategoriesId:
                        destinationCategories ||
                        (selectedImage &&
                            selectedImage.destinationCategoriesId),
                    destinationSubCategoriesId:
                        destinationSubCategories ||
                        (selectedImage &&
                            selectedImage.destinationSubCategoriesId),
                    projectName:
                        props.selectedProjectData.projectName
                }}
                />
                 
              </Card>
          </CustomModal>

      </>
  );
};


const mapStateToProps = (state) => ({
  token: state.loggedUser.token,
  storeOverview: state.accountOverview.store.storeOverview,
  UserPermission: state.accountOverview.store.StoreUserPermission,
  accessLevel: state.loggedUser.accessLevel,

});
export default connect(mapStateToProps)(GraphicsQAImageDetails);